export default __webpack_public_path__ + "static/media/14.22a94db4.jpg";